/* ---- Generated git release level information ---- */ 
export default function(){ 
  console.log("Released git SHA is e01d8263b7be97b65d4a6258efcfc94995fa8a5d"); 
  console.log("To show the release tag matching this SHA, issue following command:"); 
  console.log("git ls-remote https://github.com/perfectformsdev/perfect-forms-designer | grep e01d8263b7be97b65d4a6258efcfc94995fa8a5d"); 
} 
